<script>
export default {
  props: {
    text: String,
    variant: { type: String, default: 'danger' },
    size: { type: Number, default: 1.1 },
    withX: { type: Boolean, default: false },
  },
};
</script>

<template>
  <span :class="'badge badge-' + variant" :style="'font-size: ' + size + 'em'">
    {{ $t(text) }}
    <small v-if="withX"> <i class="fas fa-times"></i></small>
  </span>
</template>